import "@/user/common";
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// 画像のカルーセルスライダー
const imageSlider = () => {
  // ピックアップOP契約のスライドショーがない場合は何もしない
  if (!document.getElementById("js-ad-pickup-op-slider")) {
    return;
  }

  const swiperContainer = document.querySelector("#js-ad-pickup-op-slider");
  const swiperSlides = swiperContainer.querySelectorAll(
    ".swiper-wrapper .swiper-slide",
  );

  // eslint-disable-next-line no-new
  new Swiper("#js-ad-pickup-op-slider", {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    loop: swiperSlides.length > 1,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      prevEl: ".swiper-button-prev",
      nextEl: ".swiper-button-next",
    },
  });
};

document.addEventListener("DOMContentLoaded", () => {
  // 初期表示
  imageSlider();
});
